document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.open-subtraining').forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
  
        const id = this.getAttribute('data-id');
        const drawer = document.getElementById('subtraining-drawer');
        const container = document.getElementById('subtrainingContent');
        const template = document.getElementById('subtrainingTemplate');
  
        // Reset inhoud
        container.innerHTML = '<p>Even geduld, de traininginformatie wordt geladen...</p>';
  
        fetch('/subtraining-ophalen', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
          },
          body: JSON.stringify({ id: id })
        })
          .then(res => res.json())
          .then(data => {
            const clone = template.content.cloneNode(true);
            clone.querySelector('.subtraining-title').textContent = data.naam;
            clone.querySelector('.subtraining-image').src = data.widgetimage;
            clone.querySelector('.subtraining-image').alt = data.naam;
  
            const dagen = parseInt(data.aantaldagen ?? 0);
            clone.querySelector('.subtraining-days').textContent = `${dagen} ${dagen === 1 ? 'lesdag' : 'lesdagen'}`;
            clone.querySelector('.subtraining-intro').innerHTML = data.widgetintroduction;
            clone.querySelector('.subtraining-link').href = data.trainingurl || '#';
  
            container.innerHTML = '';
            container.appendChild(clone);
          })
          .catch(err => {
            console.error(err);
            container.innerHTML = '<p>Fout bij het laden van de traininginformatie.</p>';
          });
  
        // Open drawer (afhankelijk van je JS framework)
        //drawer.classList.add('is-open'); // of: Foundation: 
        //$('#subtraining-drawer').foundation('open')
      });
    });
  });
  